import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
    <a href='https://github.com/aknibircse' target='blank' rel="noopener"><BsGithub /></a>
    </div>
    <div>
    <a href='https://www.linkedin.com/in/aknibircse' target='blank' rel="noopener"><BsLinkedin /></a>
    </div>
    <div>
    <a href='https://www.facebook.com/aknibircse' target='blank' rel="noopener"><FaFacebookF /></a>
    </div>
  </div>
);

export default SocialMedia;
